export default {
  // OutgoingPhone
  callingNumber: 'Sender Number',
  explanation: 'Description',
  registrationDate: 'Registration Date & Time',
  state: 'Status',
};
